






























































































































































































































import { Vue, Component, Watch, Ref } from "vue-property-decorator";
import router from "@/router/router";
import { BranchFilter } from "@/data/models/BranchFilter";

import ProjectOverviewComponent from "./SimpleProjectOverview.vue";
import MenuIconWithSelectionListComponent from "@/components/common/FilterMenu.vue";
import { ToolbarContentModule } from "@/store/modules/ToolbarContent";

import {
  DryingProjectOverview,
} from "@/data/models/DryingProjectOverview";
import LeakDetectionProjectOverview from "@/data/models/LeakDetectionProjectOverview";

import SelectProjectTypeComponent from "@/components/project/type/SelectProjectType.vue";
import BranchFilterSelectorComponent from "@/components/common/BranchFilterSelector.vue";
import ConfirmationDialogComponent from "@/components/common/ConfirmationDialog.vue";

import {
  fetchArchivedProjectOverviewPageCount,
  observeArchivedProjects,
} from "@/data/repository/ArchivedProjectsObserver";
import {
  checkIfArchivedProjectsExist,
  checkIfDeletedProjectsExist,
  observeFinishedDryingProjects,
  observeRunningDryingProjects,
  observeFinishedLeakDetectionProjects,
  observeRunningLeakDetectionProjects,
} from "@/data/repository/ProjectOverviewRepository";

import { StateChanger } from "vue-infinite-loading";
import InfiniteLoading from "vue-infinite-loading";
import {
  doesClientHaveApp,
  findBranch,
  getBranchesOfClient,
  hasClientEnabledStrictBranchFilters,
  getClientId,
} from "@/data/repository/ClientRepository";

import {
  getNumber,
  setNumber,
} from "@/utils/SecureLocalStorage";

import { ProjectsModule } from "@/store/modules/ProjectsModule";
import { UserModule } from "@/store/modules/UserModule";
import ProjectListFilter from "@/assets/icons/ic_sort_projects.svg";
import {
  ArchivedProjectFilter,
  doesArchivedProjectMatchFilter,
  getArchivedFilterName,
} from "@/data/models/ProjectFilter";

import {
  getActiveUser,
  getDefaultBranchFilterOfUser,
} from "@/data/repository/UserRepository";

import { dedupeProjectsPreferringArchive } from "@/utils/RestoreAndDeleteProjectAction";
import { UserLookup } from "@/data/models/UserLookup";
import {
  ProjectStateFilter,
  ProjectStateFilterType,
} from "@/utils/ProjectStateFilter";
import { ProjectStateFilterCounter } from "@/utils/ProjectStateFilterCounter";
import User from "@/data/models/User";

import { ProjectSortOrder } from "@/data/models/ProjectSortOrder";
import { getBranchName } from "@/data/models/Branch";
import { seeAllProjectsAccess, restoreProjectAccess, deleteProjectAccess } from "@/permissions/UserPermissions";
import { getIresClientType, IresClientType } from "@/data/models/IresClient";
import { COLOR_ACCENT, COLOR_TABLE_HEADER, COLOR_TABLE_HEADER_DARK } from "@/utils/colors";
import { themed } from "@/utils/Theme";
import { 
  deleteProjects, 
  restoreProjects, 
  deleteProjectsPermanently 
} from "@/data/repository/ProjectRepository";
import { isProjectDeleted, ProjectListType } from "@/data/models/ProjectOverview";
import { ProjectDetailsModule } from "@/store/modules/ProjectDetailsModule";
import { calculateBackgroundStyle, setLastVisitedItem, StorageKeyLastVisitedItemLevel } from "@/utils/Utils";
import ProjectListTypeDisplayComponent from "../type/ProjectListDisplayType.vue";
import { getDefaultProjectTypes, ProjectTypeConfig } from "@/data/models/ProjectDetails";
import { ProjectManagementSettingsModule } from "@/store/modules/ProjectManagementSettingsModule";
import {
  sortArchivedProjects,
  sortProjectsByIresProjectNumber,
} from "@/utils/ArchivedProjectSorting";
import RestoreAndDeleteProjectsDialog from "@/components/project/list/RestoreAndDeleteProjectsDialog.vue";
import {
  ArchiveLoadProgress,
  calculateArchiveLoadPercentage,
} from "@/utils/ArchiveLoadProgress";
import ToolbarOverflowItemComponent from "@/components/common/ToolbarOverflowItem.vue";
import { getEffectiveUser } from "@/utils/ViewAs";
import { getStoredBranchFilterId } from "@/utils/BranchFilterStorage";

@Component({
  name: "ArchivedProjectsComponent",
  components: {
    "toolbar-overflow-item": ToolbarOverflowItemComponent,
    "project-list-type-display": ProjectListTypeDisplayComponent,
    "project-overview": ProjectOverviewComponent,
    "infinite-loading": InfiniteLoading,
    "project-list-filter": ProjectListFilter,
    "menu-icon": MenuIconWithSelectionListComponent,
    "select-project-type": SelectProjectTypeComponent,
    "branch-filter-selector": BranchFilterSelectorComponent,
    "confirmation-dialog": ConfirmationDialogComponent,
    "restore-delete-dialog": RestoreAndDeleteProjectsDialog,
  },
})

export default class ArchivedProjectsComponent extends Vue {
  showProjectStatus = false;
  componentActive = false;

  searchQuery = "";

  infiniteId = new Date();
  windowWidth = 0;

  projectsMatchingSearchQuery: Array<DryingProjectOverview | LeakDetectionProjectOverview> = [];

  pageSize = 20;
  sliceLength = this.pageSize;

  searchTimeout: NodeJS.Timeout | null = null;

  projectStateFilter: ProjectStateFilter | null = null;

  selectedSortOrderBeforeObservingFinishedProjects =
    ProjectSortOrder.NEWEST_FIRST;
  selectedSortOrder = ProjectSortOrder.NEWEST_FIRST;

  sortOrders = [
    ProjectSortOrder.NEWEST_FIRST,
    ProjectSortOrder.OLDEST_FIRST,
    ProjectSortOrder.PROJECT_NUMBER,
  ];

  selectedFilter = ArchivedProjectFilter.ARCHIVED_PROJECTS;
  allFilters = [
    ArchivedProjectFilter.ARCHIVED_PROJECTS,
    ArchivedProjectFilter.FINISHED_PROJECTS,
    ArchivedProjectFilter.PROJECTS_MOVED_TO_FINISHED,
    ArchivedProjectFilter.DELETED_PROJECTS,
  ];

  branchesOfClient = getBranchesOfClient();
  selectedBranchFilter = getDefaultBranchFilterOfUser();

  subscriptions: Array<() => void> = [];
  areAllProjectsObserved = false;

  storageKeySortOrder = "storageKeySortOrderProjects";
  storageKeyFilter = "storageKeyFilterProjects";
  storageKeySliceLength = "archivedProjectsListStorageKeySliceLength";
  storageKeyBranchFilter = "storageKeyBranchFilter";

  showToolbarContent = false;
  targetUser: User | null = null;

  isArchiveLoading = true;
  archiveLoadedProjects = 0;
  archiveLoadPercentage: number | null = null;
  expectedArchivePageCount: number | null = null;
  shouldObserveAllProjectsAfterLoading = false;

  isSelectionMode = false;

  selectedProjectIds: string[] = [];
  selectedProjectsLength = 0;
  shouldRecalculateSelectedProjects = false;

  isAllSelected = false;

  isProcessingProject = false;
  showNoArchivedProjectsFound = false;
  showNoDeletedProjectsFound = false;

  showingSuccessSnackbar = false;
  successSnackbarText = "";
  successSnackbarParameters: string[] = [];
  successSnackbarCountParameter: number | null = null;

  showingErrorSnackbar = false;
  errorSnackbarText = "";
  errorSnackbarParameters: string[] = [];

  showingWarningSnackbar = false;
  warningSnackbarText = "";
  warningSnackbarParameters: string[] = [];

  snackbarTimeout = 5000;

  @Ref("confirmDialog")
  confirmationDialog!: ConfirmationDialogComponent;

  @Watch("$i18n.locale")
  onLangugageChanged() {
    this.updateToolbarTitle();
  }

  @Watch("selectedFilter")
  onSelectedFilterChanged(after: ArchivedProjectFilter, before: ArchivedProjectFilter) {
    if (this.isSelectionMode && before !== after) {
      this.selectedProjectIds = [];
      this.isAllSelected = false;
    }

    if (this.isSelectionMode && !this.showSwitchSelectionModeIcon) {
      this.toggleSelectionMode();
    }
  }

  @Watch("isAllSelected")
  onIsAllSelectedChanged() {
    if (this.isAllSelected) {
      // A maximum of 100 projects can be selected for deletion/restoration
      this.selectedProjectIds = this.allProjects.slice(0, 100).map((project) => project.id);
      
      if (this.allProjects.length > 100) {
        this.showWarningSnackbar("archivedProjectList.maximumProjectsSelectionLimitWarning", "");
      }
    }
    else {
      this.selectedProjectIds = [];
    }
  }

  isArchivedProject(projectListType?: ProjectListType) {
    return projectListType === ProjectListType.ARCHIVED_PROJECTS || projectListType === ProjectListType.DELETED_PROJECTS;
  }

  get tableHeaderColor() {
    return themed(COLOR_TABLE_HEADER, COLOR_TABLE_HEADER_DARK);
  }

  /** The user whose view this shows: the chosen one while "Sicht auf" is active (ticket 2610052). */
  get activeUser() {
    return getEffectiveUser();
  }

  get projectListTypes() {
    return Object.values(ProjectListType);
  }

  get projectsListDescription() {
    // While the archive is loading the header counts what has arrived, because the list itself
    // deliberately shows nothing until all of it has. The filter is always the archived-projects
    // one at this point (it is not restored from storage), so there is no second wording to pick.
    if (this.isArchiveLoading) {
      return this.$tc(
        "archivedProjectList.description",
        this.archiveLoadedProjects
      ).toString();
    }

    const numberOfProjects = this.numberOfProjects;

    if (this.isSearchMode) {
      return this.$tc("archivedProjectList.descriptionAllProjects", numberOfProjects).toString();
    }

    if (this.isSelectionMode) {
      const numberOfProjectsSelected = this.selectedProjectsLength ?? this.selectedProjectIds.length;

      return this.isDeletedProjectsList
        ? this.$tc("archivedProjectList.descriptionSelectionModeAlt", numberOfProjectsSelected).toString()
        : this.$tc("archivedProjectList.descriptionSelectionMode", numberOfProjectsSelected).toString();
    }

    return this.isDeletedProjectsList
      ? this.$tc("archivedProjectList.descriptionAlt", numberOfProjects).toString()
      : this.$tc("archivedProjectList.description", numberOfProjects).toString();
  }

  get defaultFilterName() {
    return this.$t("archivedProjectList.filterArchivedProjects").toString();
  }

  get deleteProjectsButtonText() {
    return this.isDeletedProjectsList
      ? this.$t("archivedProjectList.permanentlyDelete").toString()
      : this.$t("archivedProjectList.delete").toString();
  }

  get isAllowedToProcessProjects() {
    return this.canDeleteProject || this.canRestoreProject;
  }

  get isDeletionAllowedForSelection() {
    return this.selectedProjectIds.length > 0 && !this.isProcessingProject;
  }

  get isDeletedProjectsList() {
    return this.selectedFilter === ArchivedProjectFilter.DELETED_PROJECTS;
  }

  get isIntermediate() {
    return this.selectedProjectIds.length > 0 &&
      this.selectedProjectIds.length !== this.numberOfProjects;
  }

  get isRestorationAllowedForSelection() {
    return this.selectedProjectIds.length > 0 && !this.isProcessingProject;
  }

  get showSwitchSelectionModeIcon() {
    return this.projectsToDisplay.length > 1 && !this.isSearchMode;
  }

  get selectionModeButtonText() {
    if (this.isDeletedProjectsList) {
      return this.isSelectionMode
        ? this.$t("archivedProjectList.deletedProjectsOverview").toString()
        : this.$t("archivedProjectList.manageDeletedProjects").toString();
    }

    return this.isSelectionMode
      ? this.$t("archivedProjectList.oldProjectsOverview").toString()
      : this.$t("archivedProjectList.manageOldProjects").toString();
  }

  /**
   * The progress bar's label. It is dropped entirely on the first load of a client's archive in
   * this browser, where there is no remembered size to measure against and the bar runs
   * indeterminate; the header's project count still grows with every slice that lands.
   */
  get archiveLoadingText() {
    // Padded with FIGURE SPACE (U+2007), which is exactly one digit wide: the label sits to the
    // right of the bar, so without it every digit the percentage gains shifts the bar sideways.
    // Padding the number rather than reserving a box for the whole label keeps the gap between
    // the two tight in every locale, whatever the surrounding words are.
    const percentage = String(this.archiveLoadPercentage).padStart(3, "\u2007");

    return this.$t("archivedProjectList.loadingArchive", [percentage]).toString();
  }

  get showProjectsHint() {
    return !this.isSelectionMode && this.isAllowedToProcessProjects;
  }

  get showNoProjectsFound() {
    // Nothing is missing while the archive is still arriving, so "keine Projekte gefunden" would
    // be a lie: it is what a user searching during the load used to be told.
    if (this.isArchiveLoading) {
      return false;
    }

    if (this.isSearchMode) {
      return true;
    }

    return this.selectedFilter === ArchivedProjectFilter.DELETED_PROJECTS
      ? this.showNoDeletedProjectsFound
      : this.selectedFilter === ArchivedProjectFilter.ARCHIVED_PROJECTS
        ? this.showNoArchivedProjectsFound
        : true;
  }

  get hasReachedMaximumSelectionLimit() {
    return this.selectedProjectIds.length >= 100;
  }

  get projectManagementSettings() {
    return ProjectManagementSettingsModule.projectManagementSettings;
  }

  get unfilteredProjectTypes() {
    const fromStore = this.projectManagementSettings;
    const loaded: ProjectTypeConfig[] | undefined = fromStore && fromStore.projectTypes;
    const base = JSON.parse(JSON.stringify(getDefaultProjectTypes())) as ProjectTypeConfig[];

    if (loaded && Array.isArray(loaded)) {
      const map = new Map<number, ProjectTypeConfig>(loaded.map(p => [p.projectTypeId, p]));
      return base.map(p => {
        const saved = map.get(p.projectTypeId);
        return saved ? { ...p, ...saved } : p;
      });
    } else {
      return base;
    }
  }

  calculateDeletionDialogTitle(
    isDeletedProjectsList: boolean,
    numberOfProjectsDeleted: number,
    deletedProjectName?: string
  ) {
    if (numberOfProjectsDeleted === 1 && deletedProjectName) {
      return this.$t(`archivedProjects.deletionConfirmationDialog.${isDeletedProjectsList
          ? "titleAlt"
          : "title"
        }`, [deletedProjectName]).toString();
    }

    return this.$tc(`archivedProjectList.deletionConfirmationDialog.${isDeletedProjectsList
        ? "titleAlt"
        : "title"
      }`, numberOfProjectsDeleted).toString();
  }

  calculateDeletionDialogMessage(
    isDeletedProjectsList: boolean,
    numberOfProjectsDeleted: number,
    deletedProjectName?: string
  ) {
    if (numberOfProjectsDeleted === 1 && deletedProjectName) {
      return this.$t(`archivedProjects.deletionConfirmationDialog.${isDeletedProjectsList
          ? "messageAlt"
          : "message"
        }`).toString();
    }

    return this.$t(`archivedProjectList.deletionConfirmationDialog.${isDeletedProjectsList
        ? "messageAlt"
        : "message"
      }`).toString();
  }

  calculateDeletionSuccessMessage(
    isDeletedProjectsList: boolean,
    numberOfProjectsDeleted: number,
    deletedProjectName?: string
  ) {
    if (numberOfProjectsDeleted === 1 && deletedProjectName) {
      return `archivedProjects.deletionConfirmationDialog.${isDeletedProjectsList
          ? "successMessageAlt"
          : "successMessage"
        }`;
    }

    return `archivedProjectList.deletionConfirmationDialog.${isDeletedProjectsList
        ? "successMessageAlt"
        : "successMessage"
      }`;
  }

  calculateRestorationDialogTitle(
    numberOfProjectsRestored: number,
    restoredProjectName?: string
  ) {
    if (numberOfProjectsRestored === 1 && restoredProjectName) {
      return this.$t(`archivedProjects.restorationConfirmationDialog.title`, [restoredProjectName]).toString();
    }

    return this.$tc(`archivedProjectList.restorationConfirmationDialog.title`, numberOfProjectsRestored).toString();
  }

  calculateRestorationDialogMessage(
    numberOfProjectsRestored: number,
    restoredProjectName?: string
  ) {
    if (numberOfProjectsRestored === 1 && restoredProjectName) {
      return this.$t(`archivedProjects.restorationConfirmationDialog.message`).toString();
    }

    return this.$t(`archivedProjectList.restorationConfirmationDialog.message`).toString();
  }

  calculateRestorationSuccessMessage(
    numberOfProjectsRestored: number,
    restoredProjectName?: string
  ) {
    if (numberOfProjectsRestored === 1 && restoredProjectName) {
      return `archivedProjects.restorationConfirmationDialog.successMessage`;
    }

    return `archivedProjectList.restorationConfirmationDialog.successMessage`;
  }

  async deleteSelectedProjects() {
    this.shouldRecalculateSelectedProjects = true;

    if (this.canDeleteProject) {
      const isDeletedProjectsList = this.isDeletedProjectsList;
      const numberOfProjectsDeleted = this.selectedProjectIds.length;

      const deletedProjectId = this.selectedProjectIds[0];
      const deletedProjectOverview = numberOfProjectsDeleted === 1 
        ? this.projectsToDisplay.find((projectOverview) => projectOverview.id === deletedProjectId)
        : undefined;
      const deletedProjectName = deletedProjectOverview?.projectName;

      const response = await this.confirmationDialog.show({
        title: this.calculateDeletionDialogTitle(
            isDeletedProjectsList,
            numberOfProjectsDeleted,
            deletedProjectName
          ),
        message: this.calculateDeletionDialogMessage(
            isDeletedProjectsList,
            numberOfProjectsDeleted,
            deletedProjectName
          ),
        rejectMessage: this.$t("common.back").toString(),
        acceptMessage: this.$t(`${isDeletedProjectsList ? "archivedProjectList.permanentlyDelete" : "common.delete"}`).toString()
      });

      if (response) {
        this.isProcessingProject = true;

        const result = this.isDeletedProjectsList
          ? await deleteProjectsPermanently(this.selectedProjectIds)
          : await deleteProjects(this.selectedProjectIds, true);

        if (result) {
          this.showSnackbar(
            true,
            this.calculateDeletionSuccessMessage(
              isDeletedProjectsList,
              numberOfProjectsDeleted,
              deletedProjectName
            ),
            deletedProjectName ?? "",
            numberOfProjectsDeleted > 1 ? numberOfProjectsDeleted : undefined,
          );
        }
        else {
          this.showSnackbar(
            false,
            `archivedProjectList.deletionConfirmationDialog.${this.isDeletedProjectsList
              ? "errorMessageAlt"
              : "errorMessage"
            }`,
            ""
          );
        }

        this.selectedProjectsLength = 0;
        this.selectedProjectIds = [];
        this.isAllSelected = false;
        this.isProcessingProject = false;
      }
    }

    this.shouldRecalculateSelectedProjects = false;
    return;
  }

  onOpenProjectDetails(projectId: string, index: number) {
    if (this.isSelectionMode) {
      const index = this.selectedProjectIds.indexOf(projectId, 0);
      
      if (index > -1) {
        this.selectedProjectIds.splice(index, 1);
      }
      else {
        if (this.hasReachedMaximumSelectionLimit) {
          this.showWarningSnackbar("archivedProjectList.maximumProjectsSelectionLimitWarning", "");
        }
        else {
          this.selectedProjectIds.push(projectId);
        }
      }
    }
    else if (this.isSearchMode) {
      ProjectDetailsModule.cacheProjectDetailsState(null);
      const sortOrder = this.selectedSortOrder;

      setNumber(
        this.storageKeySliceLength,
        this.pageSize + Math.floor(index / this.pageSize) * this.pageSize
      );

      setLastVisitedItem(
        projectId,
        StorageKeyLastVisitedItemLevel.LEVEL_1,
      );
      
      router.push({
        path: `projects/${projectId}`,
        params: {
          projectId: projectId
        },
        query: {
          ignoreUserRequirements: "true",
          sortOrder: (
            sortOrder ?? ProjectSortOrder.NEWEST_FIRST
          ).toString(),
          isProjectsTab: "true"
        }
      });
    }
  }

  /**
   * Offers restore / delete for a single project of the archive. The dialog is
   * mounted with the page and is handed the project directly, so the click
   * that opens it never has to wait for a render.
   */
  onRestoreOrDeleteProject(
    projectOverview: DryingProjectOverview | LeakDetectionProjectOverview
  ) {
    this.restoreDeleteProjectsDialog.show(
      projectOverview,
      this.isArchivedProject(projectOverview.projectListType)
    );
  }

  async restoreSelectedProjects() {
    this.shouldRecalculateSelectedProjects = true;

    if (this.canRestoreProject) {
      const numberOfProjectsRestored = this.selectedProjectIds.length;

      const restoredProjectId = this.selectedProjectIds[0];
      const restoredProjectOverview = numberOfProjectsRestored === 1 
        ? this.projectsToDisplay.find((projectOverview) => projectOverview.id === restoredProjectId)
        : undefined;
      const restoredProjectName = restoredProjectOverview?.projectName;
      
      const response = await this.confirmationDialog.show({
        title: this.calculateRestorationDialogTitle(numberOfProjectsRestored, restoredProjectName),
        message: this.calculateRestorationDialogMessage(numberOfProjectsRestored, restoredProjectName),
        rejectMessage: this.$t("common.back").toString(),
        acceptMessage: this.$t("common.restore").toString()
      });

      if (response) {
        this.isProcessingProject = true;

        const result = await restoreProjects(this.selectedProjectIds);

        if (result) {
          this.showSnackbar(
            true,
            this.calculateRestorationSuccessMessage(numberOfProjectsRestored, restoredProjectName),
            restoredProjectName ?? "",
            numberOfProjectsRestored > 1 ? numberOfProjectsRestored : undefined,
          );

          
        }
        else {
          this.showSnackbar(
            false,
            `archivedProjectList.restorationConfirmationDialog.errorMessage`,
            ""
          );
        }

        this.selectedProjectsLength = 0;
        this.selectedProjectIds = [];
        this.isAllSelected = false;
        this.isProcessingProject = false;
      }
    }

    this.shouldRecalculateSelectedProjects = false;
    return;
  }

  getAllFiltersName() {
    let filtersName = "";

    const projectStateFilter = this.projectStateFilter;

    if (projectStateFilter) {
      const mainFilterName = new ProjectStateFilterCounter(
          projectStateFilter.filterType
        ).getDescription(this);
      
      if (mainFilterName !== this.defaultFilterName) {
        filtersName += mainFilterName;
      }  
    }
    
    const selectedFilterName = this.getProjectFilterName(this.selectedFilter);
    if (selectedFilterName !== this.defaultFilterName) {
      if (filtersName === "") {
        filtersName += selectedFilterName;
      }
      else {
        filtersName += ", " + selectedFilterName;
      }
    }

    const selectedBranchFilterName = this.selectedBranchFilter.branch
      ? getBranchName(this.selectedBranchFilter.branch)
      : this.$t("common.all");

    if (selectedBranchFilterName !== this.$t("common.all")) {
      if (filtersName === "") {
        filtersName += selectedBranchFilterName;
      }
      else {
        filtersName += ", " + selectedBranchFilterName;
      }
    }

    return filtersName;
  }

  getDeleteIconColor() {
    return COLOR_ACCENT;
  }

  getRestoreIconColor() {
    return COLOR_ACCENT;
  }

  getSortOrderName(sortOrder: ProjectSortOrder) {
    switch (sortOrder) {
      case ProjectSortOrder.NEWEST_FIRST:
        return this.$t("projectList.newestProjets");
      case ProjectSortOrder.OLDEST_FIRST:
        return this.$t("projectList.oldestProjects");
      case ProjectSortOrder.PROJECT_NUMBER:
        return this.$t("projectList.projectNumber");
    }
  }

  getProjectFilterName(archivedProjectFilter: ArchivedProjectFilter) {
    return getArchivedFilterName(this, archivedProjectFilter);
  }

  @Watch("selectedProjectIds")
  onSelectedProjectIdsChanged() {
    this.selectedProjectsLength = this.selectedProjectIds.length;
  }

  isProjectSelected(projectId: string) {
    return this.selectedProjectIds.includes(projectId);
  }

  showSnackbar(
    isSuccessSnackbar: boolean,
    message: string,
    parameter: string,
    countParameter?: number, 
  ) {
    const isProjectsListEmpty = this.projectsToDisplay.length === 0;
    
    if (this.selectedFilter === ArchivedProjectFilter.DELETED_PROJECTS) {
      this.showNoDeletedProjectsFound = isProjectsListEmpty;
    }
    else {
      this.showNoArchivedProjectsFound = isProjectsListEmpty;
    }

    if (isProjectsListEmpty && this.isSelectionMode) {
      this.toggleSelectionMode()
    }

    this.isProcessingProject = false;

    if (countParameter || countParameter === 0) {
      this.successSnackbarCountParameter = countParameter;
    }
    else {
      this.successSnackbarCountParameter = null;
    }

    isSuccessSnackbar
      ? this.showSuccessSnackbar(message, parameter)
      : this.showErrorSnackbar(message, parameter);
  }

  setIsProcessingProject() {
    this.isProcessingProject = true;
  }

  showErrorSnackbar(
    message: string,
    ...parameters: string[]
  ) {
    this.showingErrorSnackbar = true;
    this.errorSnackbarText = message;
    this.errorSnackbarParameters = parameters;
  }

  showSuccessSnackbar(
    message: string, 
    ...parameters: string[]
  ) {
    this.showingSuccessSnackbar = true;
    this.successSnackbarText = message;
    this.successSnackbarParameters = parameters;
  }

  showWarningSnackbar(
    message: string, 
    ...parameters: string[]
  ) {
    this.showingWarningSnackbar = true;
    this.warningSnackbarText = message;
    this.warningSnackbarParameters = parameters;
  }

  toggleSelectionMode() {
    this.selectedProjectIds = [];
    this.isAllSelected = false;

    this.isSelectionMode = !this.isSelectionMode;
  }

  @Ref("selectProjectType")
  selectProjectType!: SelectProjectTypeComponent;

  @Ref("restoreDeleteProjectsDialog")
  restoreDeleteProjectsDialog!: RestoreAndDeleteProjectsDialog;

  @Watch("selectedSortOrder")
  onSortOrderChanged() {
    this.updateToolbarTitle();
  }

  @Watch("selectedFilter")
  onFilterChanged() {
    this.resetDisplayedProjects();
    this.updateToolbarTitle();
  }

  @Watch("selectedBranchFilter")
  onBranchFilterChanged() {
    this.resetDisplayedProjects();
  }

  get sortOrderMenuIconRes() {
    return "mdi-sort-alphabetical-variant";
  }

  get projectFilterIconRes() {
    return "mdi-filter-variant";
  }

  get canSeeAllProjects() {
    return seeAllProjectsAccess(this.activeUser);
  }

  get users() {
    return UserModule.users;
  }

  get userLookup() {
    return new UserLookup(this.users);
  }

  updateToolbarTitle() {
    const prefix = this.$t("archivedProjectList.title").toString();
    const selectedFilterName = this.getProjectFilterName(this.selectedFilter);
    const projectsString = selectedFilterName !== this.defaultFilterName
      ? `${prefix} (${selectedFilterName})` 
      : `${prefix}`;

    // No "(Sicht <name>)" here: the Sicht auf chip beside the title names them (ticket 2610050).
    ToolbarContentModule.setToolbarTitle(
      this.isSearchMode
        ? this.$t("archivedProjectList.titleAllProjects").toString()
        : projectsString
    );
  }

  /**
   * The search, sort and filter controls are portalled into the app bar behind `componentActive`,
   * so nothing here may be awaited before it is set. The two existence checks below are Firestore
   * round trips, and waiting for them left the app bar without its controls on every return to
   * this page: long enough on a slow connection for `Scaffold` to give up and show the client /
   * user context fallback in their place. They only decide whether a "nothing found" hint may
   * appear, which can settle later, and they are independent of each other.
   */
  async activated() {
    this.componentActive = true;
    this.updateToolbarTitle();
    this.refreshExpectedArchivePageCount();

    const branchIdQuery = getStoredBranchFilterId("branchFilter");

    if (branchIdQuery) {
      const matchingBranch = findBranch(branchIdQuery);

      if (matchingBranch) {
        this.selectedBranchFilter = new BranchFilter(
          hasClientEnabledStrictBranchFilters(),
          matchingBranch
        );
      }
    }

    const [hasArchivedProjects, hasDeletedProjects] = await Promise.all([
      checkIfArchivedProjectsExist(),
      checkIfDeletedProjectsExist(),
    ]);

    this.showNoArchivedProjectsFound = !hasArchivedProjects;
    this.showNoDeletedProjectsFound = !hasDeletedProjects;
  }

  deactivated() {
    this.componentActive = false;
  }

  mounted() {
    this.componentActive = true;
    this.updateToolbarTitle();
    this.onWindowsResize();
  }

  reloadProjectsList() {
    if (this.searchQuery && this.searchQuery !== "") {
      this.processSearchQuery(this.searchQuery);
    }
  }

  @Watch("archivedProjects")
  onArchivedProjectsChanged() {
    this.reloadProjectsList();
  }

  /**
   * The raw overview lists the search reads, referenced without copying them,
   * so that a snapshot can be detected cheaply while no search is running.
   */
  get searchableProjectSources() {
    return [
      ProjectsModule.runningDryingProjects,
      ProjectsModule.finishedDryingProjects,
      ProjectsModule.runningLeakDetectionProjects,
      ProjectsModule.finishedLeakDetectionProjects,
    ];
  }

  @Watch("searchableProjectSources")
  onSearchableProjectSourcesChanged() {
    this.reloadProjectsList();
  }

  get archivedProjects() {
    return ProjectsModule.archivedProjects
      .map((project) => {
        const updatedProject = { ...project }; 
        
        updatedProject.projectListType = isProjectDeleted(project)
            ? ProjectListType.DELETED_PROJECTS
            : ProjectListType.ARCHIVED_PROJECTS;

        return updatedProject;
    });
  }

  get runningDryingProjects() {
    return ProjectsModule.runningDryingProjects
      .map((project) => {
        const updatedProject = { ...project }; 
        
        updatedProject.projectListType = ProjectListType.RUNNING_PROJECTS;

        return updatedProject;
    });
  }

  get finishedDryingProjects() {
    return ProjectsModule.finishedDryingProjects
      .map((project) => {
        const updatedProject = { ...project }; 
        
        updatedProject.projectListType = ProjectListType.FINISHED_PROJECTS;

        return updatedProject;
    });
  }
  
  get runningLeakDetectionProjects() {
    return ProjectsModule.runningLeakDetectionProjects
      .map((project) => {
        const updatedProject = { ...project }; 
        
        updatedProject.projectListType = ProjectListType.RUNNING_PROJECTS;

        return updatedProject;
    });
  }

  get finishedLeakDetectionProjects() {
    return ProjectsModule.finishedLeakDetectionProjects
      .map((project) => {
        const updatedProject = { ...project }; 
        
        updatedProject.projectListType = ProjectListType.FINISHED_PROJECTS;

        return updatedProject;
    });
  }

  get projects() {
    const projects = [
      ...this.runningDryingProjects,
      ...this.finishedDryingProjects,
      ...this.runningLeakDetectionProjects,
      ...this.finishedLeakDetectionProjects,
    ];

    return projects;
  }

  get showLeakDetectionProjects() {
    return doesClientHaveApp();
  }

  @Watch("isSearchMode")
  onSearchModeChanged() {
    this.updateToolbarTitle();
  }

  get isSearchMode() {
    return this.searchQuery !== "";
  }

  /**
   * Running and finished project overviews are only needed by the search
   * across all projects, so they are observed on the first search instead of
   * on page load: loading the whole project history of a client on top of an
   * archive of >10k projects is what makes opening this page slow.
   *
   * They also wait for the archive to finish. Starting four more collection listeners while it
   * is still downloading makes them share the connection with it, which on a slow line is what
   * made the archive appear to stop loading the moment the user typed in the search field.
   */
  observeAllProjects() {
    if (this.areAllProjectsObserved) {
      return;
    }

    if (this.isArchiveLoading) {
      this.shouldObserveAllProjectsAfterLoading = true;
      return;
    }

    this.areAllProjectsObserved = true;

    this.subscriptions.push(observeRunningDryingProjects());
    this.subscriptions.push(observeFinishedDryingProjects());

    if (this.showLeakDetectionProjects) {
      this.subscriptions.push(observeRunningLeakDetectionProjects());
      this.subscriptions.push(observeFinishedLeakDetectionProjects());
    }
  }

  selectSortOrder(selectedSortOrder: ProjectSortOrder) {
    if (selectedSortOrder === this.selectedSortOrder) {
      return;
    }

    this.selectedSortOrder = selectedSortOrder;
    this.resetDisplayedProjects();
  }

  async created() {
    const activeUser = this.activeUser;
    this.showProjectStatus = doesClientHaveApp();

    this.refreshExpectedArchivePageCount();
    this.observeArchivedProjects();

    // "Sicht auf" is one choice for the whole app (ticket 2610050); Scaffold re-creates the page when
    // it changes, so reading it once here is enough.
    this.targetUser = activeUser;

    const projectStateFilterTypeQuery =
      router.currentRoute.query["projectStateFilterType"] ?
      router.currentRoute.query["projectStateFilterType"] :
      "OVERALL";

    if (projectStateFilterTypeQuery) {
      this.projectStateFilter = new ProjectStateFilter(
        projectStateFilterTypeQuery as ProjectStateFilterType
      );
    }

    const sortOrderQuery = router.currentRoute.query["sortOrder"];

    if (sortOrderQuery) {
      this.selectedSortOrder = Number.parseInt(sortOrderQuery as string);
    } else {
      const cachedSortOrder = getNumber(this.storageKeySortOrder);

      if (cachedSortOrder != null) {
        this.selectedSortOrder = cachedSortOrder;
      }
    }

    const cachedSliceLength = getNumber(this.storageKeySliceLength);
    if (cachedSliceLength) {
      this.sliceLength = cachedSliceLength;
      setNumber(this.storageKeySliceLength);
    }

    this.updateToolbarTitle();
  }

  beforeDestroy() {
    this.subscriptions.forEach((subscription) => {
      subscription();
    });

    setNumber(this.storageKeyFilter, this.selectedFilter);
    setNumber(this.storageKeySortOrder, this.selectedSortOrder);
  }

  /**
   * Fetches the archive's page count, the denominator of the progress bar's percentage.
   *
   * Counted server-side per visit rather than remembered in the browser. The previous version
   * read a size `localStorage` had kept from the last completed load, which `signOut()` destroyed
   * along with everything else, so the percentage was absent on the first load of every session.
   *
   * Called from `activated()` as well as `created()` **because this component is kept alive**
   * (`Scaffold.vue`'s `<keep-alive>`, via the route's `keepAlive` meta): `created()` runs once per
   * cached instance, not once per visit, and the archive grows between visits.
   *
   * Deliberately not awaited by its callers. The load starts immediately and the bar runs
   * indeterminate for the one round trip this takes, rather than the whole list waiting on a
   * progress bar.
   */
  async refreshExpectedArchivePageCount() {
    this.expectedArchivePageCount = await fetchArchivedProjectOverviewPageCount();
  }

  observeArchivedProjects() {
    this.subscriptions.push(
      observeArchivedProjects((progress) => this.onArchiveLoadProgress(progress))
    );
  }

  /**
   * Advances the progress bar on each slice of the archive, and releases the work that was held
   * back until the download was out of the way.
   */
  onArchiveLoadProgress(progress: ArchiveLoadProgress) {
    // Counted through the list's own filter, so the header climbs to the number it will settle
    // on instead of overshooting it by the archive's deleted projects.
    this.archiveLoadedProjects = progress.projects.filter(
      this.buildProjectFilter()
    ).length;
    this.archiveLoadPercentage = calculateArchiveLoadPercentage(
      progress,
      this.expectedArchivePageCount
    );

    if (!progress.isComplete || !this.isArchiveLoading) {
      return;
    }


    this.isArchiveLoading = false;

    // Also into the live component, not only into storage. Without this the instance that just
    // measured the archive is the one instance that still has no denominator, so the next load it
    // runs would go indeterminate again.
    this.expectedArchivePageCount = progress.loadedPages;

    if (this.shouldObserveAllProjectsAfterLoading) {
      this.shouldObserveAllProjectsAfterLoading = false;
      this.observeAllProjects();
    }
  }

  get showInfiniteLoading() {
    return this.sortedProjects.length > 0;
  }

  @Watch("projectsToDisplay")
  onProjectsToDisplayChanged() {
    if (this.shouldRecalculateSelectedProjects) {
      const projectIdsSet = new Set(this.allProjects.map(project => project.id));
      this.selectedProjectsLength = this.selectedProjectIds.filter(id => projectIdsSet.has(id)).length;
    }

    if (this.projectsToDisplay.length > 0) {
      this.showNoArchivedProjectsFound = true;
      this.showNoDeletedProjectsFound = true;
    }
  }

  get projectsToDisplay() {
    return this.sliceProjectsToDisplay(this.sliceLength);
  }

  sliceProjectsToDisplay(length: number) {
    let update;

    if (this.searchQuery) {
      update = this.projectsMatchingSearchQuery;
    } else {
      update = this.sortedProjects;
    }

    return update.slice(0, length);
  }

  onWindowsResize() {
    this.windowWidth = window.innerWidth;
  }

  async infiniteHandler(data: StateChanger) {
    const nextSliceLength = this.sliceLength + this.pageSize;
    const nextSlice = this.sliceProjectsToDisplay(nextSliceLength);

    this.sliceLength = nextSliceLength;

    if (nextSliceLength > nextSlice.length) {
      data.complete();
    } else {
      data.loaded();
    }
  }

  get numberOfProjects() {
    return this.allProjects.length;
  }

  get allProjects() {
    if (this.searchQuery) {
      return this.projectsMatchingSearchQuery;
    } else {
      return this.sortedProjects;
    } 
  }

  get isSanTecClient() {
    return getIresClientType(getClientId()) === IresClientType.SanTec;
  }

  /**
   * The predicate the displayed list is filtered by, built **once** so that everything reactive it
   * depends on is hoisted out of the per-project loop rather than read >10k times.
   *
   * Shared with the loading counter so the two can never disagree: counting raw archive documents
   * while loading and filtered ones afterwards makes the header climb past the final total and
   * then drop back to it, because the archive collection also holds the deleted projects.
   */
  buildProjectFilter(): (projectOverview: DryingProjectOverview) => boolean {
    const userLookup = this.userLookup;
    const user = this.targetUser ?? getActiveUser();

    const filter = this.selectedFilter;
    const branchFilter = this.selectedBranchFilter;

    const today = new Date();

    const projectStateFilterOptions = { ignoreUserRequirements: true };

    // The default state filter accepts every project, so it is dropped here
    // instead of being evaluated once per project.
    const projectStateFilter = this.projectStateFilter?.matchesEveryProject(
      projectStateFilterOptions
    )
      ? null
      : this.projectStateFilter;

    // `Boolean(...)`, because these filters report truthiness rather than booleans and the
    // predicate this returns is typed.
    return (projectOverview) =>
      Boolean(
        projectOverview.id &&
          branchFilter.doesProjectOverviewMatchFilter(projectOverview) &&
          doesArchivedProjectMatchFilter(filter, projectOverview) &&
          (projectStateFilter?.matchesProjectOverview(
            projectOverview,
            user,
            userLookup,
            today,
            projectStateFilterOptions
          ) ??
            true)
      );
  }

  get sortedProjects(): Array<DryingProjectOverview> {
    const userLookup = this.userLookup;

    if (!userLookup) {
      return [];
    }

    // Filtering before sorting keeps the comparator away from projects nobody
    // will see: the archive can hold >10k projects, of which most views show
    // only a fraction.
    const matchingProjects = this.archivedProjects.filter(
      this.buildProjectFilter()
    );

    return sortArchivedProjects(matchingProjects, {
      sortOrder: this.selectedSortOrder,
      isDeletedProjectsList: this.isDeletedProjectsList,
      isSanTecClient: this.isSanTecClient,
    });
  }

  debounceSearch(newQuery: string) {
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }

    if (newQuery === "") {
      this.clearSearchQuery();
      return;
    }

    // Start loading the projects outside the archive while the user is still
    // typing; results are refreshed once their snapshots arrive.
    this.observeAllProjects();

    this.searchTimeout = setTimeout(() => {
      this.processSearchQuery(newQuery);
    }, 400);
  }

  /**
   * One row per project, the archive's copy winning. A project id can sit in two overview
   * collections at once, and concatenating them gave duplicate `:key`s plus a running / finished
   * row that refuses restore. See `dedupeProjectsPreferringArchive`.
   */
  get allSearchableProjects() {
    return dedupeProjectsPreferringArchive(this.archivedProjects, this.projects);
  }

  processSearchQuery(newQuery: string) {
    const searchQueryUpperCase = newQuery.toUpperCase();

    // Search matches first, then sort: sorting every project of the client
    // before discarding almost all of them dominated the cost of a keystroke.
    const matchingProjects = this.allSearchableProjects.filter(
      (projectOverview) =>
        ((projectOverview.projectName && projectOverview.projectName
          .toUpperCase()
          .includes(searchQueryUpperCase)) ||
          projectOverview.projectNumber
            .toUpperCase()
            .includes(searchQueryUpperCase) ||
          (projectOverview.projectNumberIres &&
            projectOverview.projectNumberIres
              .toUpperCase()
              .includes(searchQueryUpperCase)) ||
          (projectOverview.projectNameErp &&
            projectOverview.projectNameErp
              .toUpperCase()
              .includes(searchQueryUpperCase)) ||
          projectOverview.id === newQuery)
    );

    this.projectsMatchingSearchQuery = sortProjectsByIresProjectNumber(
      matchingProjects
    );

    this.searchQuery = newQuery;
    this.resetDisplayedProjects();
  }

  resetDisplayedProjects() {
    this.sliceLength = this.pageSize;
    this.infiniteId = new Date();
  }

  clearSearchQuery() {
    this.searchQuery = "";
    this.resetDisplayedProjects();
  }

  get showProjectsList() {
    return this.userLookup;
  }

  get canRestoreProject() {
    return restoreProjectAccess(this.activeUser);
  }

  get canDeleteProject() {
    return deleteProjectAccess(this.activeUser);
  }

  get archivedProjectListHintParameter() {
    if (this.canDeleteProject && this.canRestoreProject) {
      if (this.isDeletedProjectsList) {
        return this.$t("archivedProjectList.restoreAndPermanentDelete");
      }
      else {
        return this.$t("archivedProjectList.restoreAndDelete");
      }
    }
    else if (this.canDeleteProject) {
      if (this.isDeletedProjectsList) {
        return this.$t("archivedProjectList.permanentlyDelete");
      }
      else {
        return this.$t("archivedProjectList.delete");
      }
    }
    else if (this.canRestoreProject) {
      return this.$t("archivedProjectList.restore");
    }

    return "";
  }

  get archivedProjectsHint() {
    if (this.projectsToDisplay.length === 0) {
      return "";
    }

    return this.$t(
      "archivedProjectList.hint",
      [this.archivedProjectListHintParameter]
    );
  }

  calculateBackgroundStyle(projectId: string) {
    return calculateBackgroundStyle(projectId);
  }

  /**
   * Phones and iPad mini (below 960 px): the search sits inside the sticky header card (the app bar
   * has it from 960 px), and the hint is left out so the header stays one line.
   */
  get isCompactHeader() {
    return this.$vuetify.breakpoint.smAndDown;
  }
}
